import { Component, Input } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'app-shared-profile',
  templateUrl: './shared-profile.component.html',
  styleUrls: ['./shared-profile.component.scss'],
})
export class SharedProfileComponent {
  @Input() seller_label: string = '';
  @Input() seller_email: string = '';
  @Input() size: 's' | 'm' | 'l' = 's';
  @Input() circle_class: string = 'sp-stroke__solid-accent';
  @Input() text_class: string = 'sp-color__accent';
  @Input() is_seller_email_visible: boolean = false;

  constructor(private auth_service: AuthService) {}

  onLogoutClick(): void {
    this.auth_service.signout().subscribe();
  }

  getCircleSize(): string {
    return `sp-circle__${this.size}`;
  }

  getTextSize(): string {
    return `sp-text__${this.size}`;
  }

  getTruncatedEmail(email: string): string {
    const index: number = email.indexOf('@');
    if (index != -1) {
      return email.substring(0, index);
    }
    return '';
  }
}
